import React from 'react';
import { Box, Tooltip, IconButton } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * ConciergeNavRail
 * A slim vertical rail (left side) with large touch targets to switch SidePanel tabs.
 *
 * Props:
 * - active: current selected id ('inbox' | 'profile' | 'settings' | 'files' | 'calendar' | 'about')
 * - onChange: (id) => void
 */
export default function ConciergeNavRail({ active = 'inbox', onChange = () => {} }) {
  const Item = ({ id, title, icon: Icon, onClick }) => {
    const selected = active === id;
    return (
      <Tooltip title={title} placement="right">
        <IconButton
          onClick={() => (onClick ? onClick() : onChange(id))}
          size="large"
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            mb: 1,
            color: selected ? '#ffffff' : 'rgba(255,255,255,0.9)',
            backgroundColor: selected ? 'rgba(255,255,255,0.22)' : 'transparent',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.28)' },
          }}
        >
          <Icon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  };

  const handleSettingsClick = () => {
    onChange("settings");
    window.dispatchEvent(new Event("openSettingsList"));
  };

  return (
    <Box
      sx={{
        width: 64,
        bgcolor: '#3786f4cb',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 1.5,
        gap: 0.5,
        boxShadow: 1,
        position: 'sticky',
        top: 0,
        height: '100vh',
        zIndex: 2,
        borderRight: '1px solid rgba(0,0,0,0.08)',
      }}
    >
      {/* top spacer / menu icon area */}
      <Box sx={{ height: 8 }} />

      <Item id="inbox" title="Inbox" icon={ChatBubbleOutlineIcon} />
      <Item id="profile" title="Profile" icon={PersonOutlineIcon} />
      <Item id="settings" title="Settings" icon={SettingsOutlinedIcon} onClick={handleSettingsClick} />
      <Item id="files" title="Files" icon={InsertDriveFileOutlinedIcon} />
      <Item id="calendar" title="Calendar" icon={CalendarTodayOutlinedIcon} />

      <Box sx={{ flexGrow: 1 }} />
      <Item id="about" title="About" icon={InfoOutlinedIcon} />
    </Box>
  );
}